import { TimeSheetType } from '../../types/timeSheet'
import API from '../axios'

const TimeRecordApi = {
  list: async (time: string, staffCode: string) => {
    try {
      const result: { data: { data: TimeSheetType } } = await API.get(
        `/timesheet/staff-timesheet?time=${time}&staffCode=${staffCode}`
      )
      return result.data
    } catch (error) {
      throw new Error('Can not get data timesheet')
    }
  },

  syncDataFromGoogleSheet: async (time: string) => {
    try {
      const result: { data: { data: TimeSheetType } } = await API.get(
        `/timesheet/sync-data?time=${time}`
      )
      return result.data
    } catch (error) {
      throw new Error('Can not sync data from google sheet')
    }
  }
}

export default TimeRecordApi
